import { useEffect, useState } from "react";

/**
 * Builds filter chip labels from current search criteria (updates as user types/selects).
 * Tag text matches column header labels via `t(fieldLabels[key])`.
 */
export function useFilterSearchTags<T extends Record<string, string>>(
  searchCriteria: T,
  fieldLabels: Record<keyof T, string>,
  t: (key: string) => string
) {
  const [searchedTags, setSearchedTags] = useState<string[]>([]);

  useEffect(() => {
    const keys = Object.keys(fieldLabels) as (keyof T)[];
    const tags = keys
      .filter((key) => String(searchCriteria[key] ?? "").trim())
      .map((key) => t(fieldLabels[key] as string));
    setSearchedTags(tags);
  }, [searchCriteria, fieldLabels, t]);

  const resolveFieldFromTag = (clickedTag: string): keyof T | undefined => {
    const keys = Object.keys(fieldLabels) as (keyof T)[];
    return keys.find((key) => t(fieldLabels[key] as string) === clickedTag);
  };

  return { searchedTags, resolveFieldFromTag };
}
